import React from 'react';
import { AlertTriangle, ArrowLeft, FileText } from 'lucide-react';

const MissingRequirementsModal = ({ isOpen, onClose, onGoBack, onUseJD }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    // Prevent closing if clicking inside the modal content
    if (e.target === e.currentTarget) {
      onClose(); // Or maybe do nothing on backdrop click? Decide based on UX preference.
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      onClick={handleBackdropClick} 
    >
      <div className="bg-white rounded-xl p-6 w-full max-w-lg shadow-xl transform transition-all">
        <div className="flex items-start gap-4 mb-4">
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center">
            <AlertTriangle className="w-5 h-5 text-yellow-600" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Define Your Requirements?</h3>
            <p className="text-sm text-gray-600 mt-1">
              You haven\'t specified \'Must Haves\' or \'Nice Haves\' yet. Adding these helps us find much better candidate matches.
            </p>
          </div>
        </div>

        <p className="text-sm text-gray-600 mb-6 text-center">
          How would you like to proceed with generating recommendations?
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={onGoBack}
            className="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors flex items-center justify-center gap-2"
          >
            <ArrowLeft size={16} />
            Go Back & Add Requirements
          </button>
          <button
            onClick={onUseJD}
            className="flex-1 px-4 py-2.5 bg-[#08f2c3] text-black font-medium rounded-lg hover:bg-[#06c19c] transition-colors flex items-center justify-center gap-2"
          >
            <FileText size={16} />
            Use Job Description Only
          </button>
        </div>
      </div>
    </div>
  );
};

export default MissingRequirementsModal; 